export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13448.7ed0cc28.jpg";